import { render, staticRenderFns } from "./ModalInsert.vue?vue&type=template&id=1b6d923c&scoped=true"
import script from "./ModalInsert.vue?vue&type=script&lang=js"
export * from "./ModalInsert.vue?vue&type=script&lang=js"
import style0 from "./ModalInsert.vue?vue&type=style&index=0&id=1b6d923c&prod&lang=scss"
import style1 from "./ModalInsert.vue?vue&type=style&index=1&id=1b6d923c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b6d923c",
  null
  
)

export default component.exports